import { render } from "./Tucs.vue?vue&type=template&id=4f9f6df7"
import script from "./Tucs.vue?vue&type=script&lang=js"
export * from "./Tucs.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__